<template>
    <div>
        <div class="checkbox-wrapper">
            <slot></slot>
        </div>
        <span class="invalid-feedback" v-if="computedError">
            <strong>{{ computedError }}</strong>
        </span>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus';

    export default {
        props: ['name', 'error'],

        data() {
            return {
                checkboxArray: [],
            }
        },

        computed: {
            computedError() {
                return this.error || this.errors(this.name);
            }
        },

        created() {
            EventBus.$on('registerCheckbox', data => {
                if (this.name == data.name) {
                    var temp = {'value': data.value, 'status': data.status};
                    this.checkboxArray.push(temp);
                }
            });
            EventBus.$on('checkboxStatusChanged', data => {
                if (this.name == data.name) {
                    this.checkboxArray.forEach(function(checkbox, index) {
                        if (checkbox.value == data.value) {
                            this[index].status = data.status;
                        }
                    }, this.checkboxArray);
                    EventBus.$emit('checkboxesChanged', {'name': this.name, 'data': this.checkboxArray});
                }
            });
        }
    }
</script>
